﻿import { Grid } from "@mui/material";
import { Control, UseFormWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  FormCheckbox,
  FormTextField,
  FormFileUpload,
  HeaderDivider,
} from "components";
import { CandidateDetailsFormData } from "../validation";

export const SpecialRequirements = ({
  control,
  watch,
}: {
  control: Control<CandidateDetailsFormData>;
  watch: UseFormWatch<CandidateDetailsFormData>;
}) => {
  const { t } = useTranslation();
  const [disability, dyslexia] = watch([
    "specialRequirements.disability",
    "specialRequirements.dyslexia",
  ]);

  return (
    <>
      <HeaderDivider
        text={t("details.specialRequirementsTitle")}
        sx={{ mb: 3 }}
      />
      <Grid container spacing={2} sx={{ mb: 8 }}>
        <Grid size={12}>
          <FormCheckbox
            name="specialRequirements.disability"
            label={t("details.disability.label")}
            control={control}
          />
        </Grid>
        <Grid size={12}>
          <FormCheckbox
            name="specialRequirements.dyslexia"
            label={t("details.dyslexia.label")}
            control={control}
          />
        </Grid>
        {(dyslexia || disability) && (
          <>
            <Grid size={12}>
              <FormTextField
                name="specialRequirements.description"
                label={t("details.specialRequirements.description.label")}
                placeholder={t(
                  "details.specialRequirements.description.placeholder"
                )}
                control={control}
                multiline
                minRows={2}
                maxRows={10}
                required
              />
            </Grid>
            <Grid size={12}>
              <FormFileUpload
                name="specialRequirements.files"
                label={t("details.specialRequirements.files.label")}
                control={control}
                required
                maxFiles={5}
              />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};
